module.exports = __webpack_public_path__ + "static/media/w1.97f22ee5.png";